__turbopack_context__.v({
  "beta": "styles-module-scss-module__0LU0hG__beta",
  "betaTitle": "styles-module-scss-module__0LU0hG__betaTitle",
  "title": "styles-module-scss-module__0LU0hG__title",
});
